import { Routes as NgRoutes } from '@angular/router';
import { NoContentComponent } from "./no-content/no-content.component";
import {HomeComponent} from './home/home.component';
import {Szechenyi2020Component} from './szechenyi2020/szechenyi2020.component';

export const Routes: NgRoutes = [
  {path: '', component: HomeComponent},
  {path: 'szechenyi2020', component: Szechenyi2020Component},
  {path: '**', component: NoContentComponent},
];



// WEBPACK FOOTER //
// C:/Projects/dod/companyintroduction/src/app/app.routes.ts